import React from 'react';
import Button from '../../../components/Button';
import styled from 'styled-components/macro';

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;
`;

const FunctionButton = styled(Button)`
  && {
    background-color: #fff;
    color: #1e202d;
    min-width: 29px;
    width: 120px;
  }
`;

const FunctionButtonsView = props => {
  return (
    <div>
      <ButtonRow>
        {props.row.map((button, buttonIndex) => {
          return (
            <FunctionButton
              key={'button' + buttonIndex}
              disabled={button.disabled}
              onClick={() => {
                props.onClickButton(button);
              }}
            >
              {button.label}
            </FunctionButton>
          );
        })}
      </ButtonRow>
    </div>
  );
};

export default FunctionButtonsView;
